export default __webpack_public_path__ + "static/media/plain-sticker-wa.bfe10dc8.png";